import { render } from "./TestResultCheckAnswer.vue?vue&type=template&id=3571ac28&scoped=true"
import script from "./TestResultCheckAnswer.vue?vue&type=script&lang=js"
export * from "./TestResultCheckAnswer.vue?vue&type=script&lang=js"

import "./TestResultCheckAnswer.vue?vue&type=style&index=0&id=3571ac28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3571ac28"]])

export default __exports__